import { ProjectPickerAction } from '@store/actions';
import {
  BrandConfig,
  IProjectPicker,
  ProjectPickerActionTypes,
  RequestStatus,
} from '@store/types';
import {
  Brand,
  NavigationTabType as TT,
  ProjectPickerStorageKeys,
} from '@models';

const lastUsedAccountId = localStorage.getItem(
  ProjectPickerStorageKeys.lastUsedAccountId
) as string;

const lastUsedProjectId = localStorage.getItem(
  ProjectPickerStorageKeys.lastUsedProjectId
);
const historical = localStorage.getItem(
  ProjectPickerStorageKeys.lastUsedProjectHistory
);

const clonoSeqConfig: BrandConfig = {
  name: 'ClonoSEQ',
  experimentFormat: 'csv',
  experimentFilename: 'Experiment_List.csv',
  defaultTabs: [TT.ORDERS, TT.RESULTS, TT.UPLOAD, TT.HELP],
};

const immunoSeqConfig: BrandConfig = {
  name: 'ImmunoSEQ',
  experimentFormat: 'tsv',
  experimentFilename: 'immunoSEQ_hsTCRB_ExpList.tsv',
  defaultTabs: [TT.ORDERS, TT.RESULTS, TT.UPLOAD, TT.HELP],
};

const configMap: Record<Brand, BrandConfig> = {
  ClonoSEQ: clonoSeqConfig,
  ImmunoSEQ: immunoSeqConfig,
};

const INIT_STATE: IProjectPicker = {
  activeAccountId: lastUsedAccountId ? lastUsedAccountId : null,
  activeProjectId: lastUsedProjectId ? lastUsedProjectId : null,
  projectsList: null,
  getProjectsStatus: RequestStatus.none,
  accountsList: null,
  history: historical ? JSON.parse(historical).reverse() : [],
  hasSampleLevelDocuments: false,
  reportNumberPrefix: '',
  timeZone: '',
  config: undefined,
};

export const projectPickerReducer = (
  state = INIT_STATE,
  Action: ProjectPickerAction
) => {
  switch (Action.type) {
    case ProjectPickerActionTypes.UPDATE_ACCOUNT_ID:
      localStorage.setItem(
        ProjectPickerStorageKeys.lastUsedAccountId,
        Action.payload
      );
      return (state = {
        ...state,
        activeAccountId: Action.payload,
      });
    case ProjectPickerActionTypes.UPDATE_PICKER:
      const nState = {
        ...state,
        activeAccountId: Action.payload.accountId,
        activeProjectId: Action.payload.projectId,
        history: [...state.history, Action.payload],
        hasSampleLevelDocuments: Action.payload.hasSampleLevelDocuments,
        reportNumberPrefix: Action.payload.reportNumberPrefix,
        timeZone: Action.payload.timezone,
        config: configMap[Action.payload.brand],
      };
      // localStorage - accountId
      localStorage.setItem(
        ProjectPickerStorageKeys.lastUsedAccountId,
        Action.payload.accountId
      );
      // localStorage - projectId
      localStorage.setItem(
        ProjectPickerStorageKeys.lastUsedProjectId,
        Action.payload.projectId
      );
      // remove current history
      localStorage.removeItem(ProjectPickerStorageKeys.lastUsedProjectHistory);
      // set new history
      localStorage.setItem(
        ProjectPickerStorageKeys.lastUsedProjectHistory,
        JSON.stringify(nState.history)
      );
      return nState;
    case ProjectPickerActionTypes.UPDATE_ACCOUNTS_LIST:
      return (state = {
        ...state,
        accountsList: Action.payload,
      });
    case ProjectPickerActionTypes.REQUEST_PROJECTS_LIST:
      return (state = {
        ...state,
        getProjectsStatus: RequestStatus.inProgress,
      });
    case ProjectPickerActionTypes.UPDATE_PROJECTS_LIST:
      return (state = {
        ...state,
        projectsList: Action.payload,
        getProjectsStatus: RequestStatus.completed,
      });
    default:
      return state;
  }
};
